import { IWithWorksheetInjectedProps } from 'Components/Worksheets/Core';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, TextOutput } from '../../../../../Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { ListFieldSection, SectionGroup } from '../../../../../Layout';
import AtterbergLimitChartSection from '../../../Shared/ChartSection';

let AsLiquidLimitFourPointResultsSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const determinationPerformed = useSelector(
    pipe(createWorksheetSelector!('LiquidLimit.NonPlastic'), valueOrDefault(false), (np) => !np)
  );

  return (
    <>
      <SectionGroup heading="Result">
        <NamePrefixModifier namePrefix="flowChart">
          <AtterbergLimitChartSection visible={determinationPerformed} />
        </NamePrefixModifier>
        <ListFieldSection>
          <Field input={<TextOutput />} label="Liquid Limit" name="Results.LiquidLimitText" />
        </ListFieldSection>
      </SectionGroup>
    </>
  );
};

AsLiquidLimitFourPointResultsSection = withInjectedProps(AsLiquidLimitFourPointResultsSection);

export { AsLiquidLimitFourPointResultsSection };
export default AsLiquidLimitFourPointResultsSection;
